import styled from '@emotion/styled';

export const ShareLinkTitle = styled.h3`
  margin: 24px 0 0;
  font: normal 14px 'Roboto';
  font-weight: 400;
  line-height: normal;
  color: var(--767676-modals-profile-share-modal);
`;
